import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { UtentiService } from './utenti.service';
import { AuthService } from './auth.service';

@Injectable()
export class JossoService {
	previousSessionId: string = null;
	ssoSessionId: string = null;
	sendingCheck: boolean = false;
	sendingLogout: boolean = false;
	checker: any = null;
	checks: number = 0;
	checkEnded: string = null;
	lastCookieCheck: number = 0;
	loginMessage: string = '';
	reloadUser: boolean = false;

	constructor(private router: Router, private cookieService: CookieService, private authService: AuthService, private utentiService: UtentiService) {
		console.log("SRV|JS - ALIVE!");
	}

	getStoredCookie(){
		let ssoSessionIdLocal = this.cookieService.get('JOSSO_SESSIONID');
		if(ssoSessionIdLocal){
			this.ssoSessionId = ssoSessionIdLocal;
		}
	}

	cookieNotExpired(){
		let now = Date.now();
		if((now - this.lastCookieCheck) > 30000){
			this.lastCookieCheck = now;
			this.getSessionCookie();
		}
	}

	getSessionCookie() {
		//console.log("SRV|JS - getSessionCookie");
		this.loginMessage = '';
		this.previousSessionId = this.ssoSessionId;
		this.ssoSessionId = null;
		this.cookieService.remove('JOSSO_SESSIONID');
		this.sendingCheck = true;
		this.checker = setInterval(
			() => {
				this.getStoredCookie();
				if (this.ssoSessionId) {
					this.sendingCheck = false;
					console.log("SRV|JS - JOSSO CHECKS ENDED ssoSessionId");
					clearInterval(this.checker);
					this.checker = null;
					//console.log("SRV|JS - getSessionCookie previousSessionId", this.previousSessionId, " ssoSessionId", this.ssoSessionId);
					if (this.ssoSessionId == this.previousSessionId) {
						this.authService.aritUserVerified = true;
						if (this.reloadUser) {
							this.reloadUser = false;
							this.getJossoUser();
						}
					}else{
						this.getJossoUser();
					}
				}else{
					this.checks++;
					console.log("SRV|JS - JOSSO CHECKS:", this.checks);
					this.checkEnded = this.cookieService.get('JOSSO_LOGIN_ENDED');
					if (this.checkEnded || this.checks > 10) {
						console.log("SRV|JS - JOSSO CHECKS ENDED no ssoSessionId");
						clearInterval(this.checker);
						this.checker = null;
						this.checks = 0;
						this.sendingCheck = false;
						if (this.authService.firstLogin) {
							this.authService.firstLogin = false;
						}else {
							this.loginMessage = 'username o password errati';
						}
						this.goToNextPage('login');
					}
				}
			},
			1000
		);
	}

	goToNextPage(page) {
		console.log("SRV|JS - GO-TO-NEXT-PAGE", page);
		this.authService.resetLoginCookies();
		this.router.navigate(['/'+page]);
	}

	getJossoUser() {
		console.log("SRV|JS - GET-JOSSO-USER");
		if (this.ssoSessionId) {
			this.authService.getJossoUser().subscribe(
				data => {
					//console.log("SRV|JS - JOSSO-USER", data);
					this.cookieService.remove('verify_user');
					if (data) {
						if (this.utentiService.getUser()) {
							if (data.name != this.utentiService.getUser().username) {
								this.authService.aritUserVerified = false;
								console.log("SRV|JS - getJossoUser data present", data, this.utentiService.getUser());
								this.sendLogout();
								this.reloadUser = true;
								this.getSessionCookie();
							}else{
								this.authService.aritUserVerified = true;
							}
						}else{
							let parsedUser = this.parseJossoUser(data);
							this.verifyAritUser(parsedUser);
						}
					}else {
						console.log("SRV|JS - getJossoUser no data");
						this.cookieService.remove('JOSSO_SESSIONID');
						this.loginMessage = 'sessione non più valida';
						this.sendLogout();
					}
				}
			);
		}
	}

	parseJossoUser(jossoUser) {
		let username = jossoUser.name;
		let nome = '';
		let cognome = '';
		let codice_fiscale = '';
		let email = '';
		let pec = '';

		for (let property of jossoUser.properties) {
			if (property['!name'] == 'user.name') {
				nome = property['!value'];
			}else if (property['!name'] == 'user.lastName') {
				cognome = property['!value'];
			}else if (property['!name'] == 'aritFiscalCode') {
				codice_fiscale = property['!value'];
			}else if (property['!name'] == 'email') {
				email = property['!value'];
			}else if (property['!name'] == 'aritPEC') {
				pec = property['!value'];
			}
		}

		let parsedUser = {
			username: username,
			nomeCompleto: nome + ' ' + cognome,
			codice_fiscale: codice_fiscale,
			email: email,
			pec: pec
		}
		//console.log("SRV|JS - JOSSO-PARSED-USER", parsedUser);
		return parsedUser;
	}

	verifyAritUser(user){
		this.authService.verifyAritUser(user).subscribe(
			(data) => {
				console.log("verifyAritUser data", data);
				if(data.success){
					this.authService.aritUserVerified = true;
					this.authService.storeUserData(null, data.user);
					this.goToNextPage(this.authService.lastVisited);
				}else{
					this.loginMessage = 'errore login';
					this.goToNextPage('login');
				}
			}
		);
	}

	sendLogout() {
		this.sendingLogout = true;
		this.lastCookieCheck = 0;
		this.ssoSessionId = null;
		this.authService.logout();
	}
}
